<div *ngIf="column.type != 'boolean'">
  <p
    [style]="cellStyle"
    class="m-0"
    [style.textAlign]="column.align || 'center'"
    [style.fontSize.rem]="fontSize"
    [style.lineHeight.px]="32 * fontSize + 6"
  >
    {{
      column.pipeToken && data[column.field] != null
        ? (data[column.field]
          | dynamicPipe: column.pipeToken : column.pipeArgs ?? [])
        : data[column.field]
    }}

    <ng-template
      [ngTemplateOutlet]="contentTemplate"
      [ngTemplateOutletContext]="{ data: data, column: column }"
    ></ng-template>
  </p>
</div>

<div
  [style]="cellStyle"
  [style.textAlign]="column.align || 'center'"
  *ngIf="column.type == 'boolean'"
>
  <fa-icon
    [style.fontSize.rem]="fontSize"
    [style.lineHeight.px]="32 * fontSize + 6"
    [ngClass]="{ success: data[column.field] }"
    [icon]="data[column.field] ? ['fas', 'circle-check'] : ['fal', 'circle']"
  ></fa-icon>
</div>
